import React, { useEffect, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import useLocale from 'helpers/hooks/useLocale';

interface Option {
  name: string;
  value: string | number;
}

interface SortDropdownProps {
  setSelectedOption?: (option: Option) => void;
  selectButtonClassName: string;
  options: { label: string; value: string }[]; // Adjust the shape of options as per your data
  defaultValue: string;
  handleClickSortIndex: () => void;
}

const SortDropdown: React.FC<any> = ({
  setSelectedOption,
  selectButtonClassName,
  options,
  defaultValue,
  mainIndex,
  handleClickSortIndex,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | number>('Please Select One');
  const { locale } = useLocale();
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const eventName = `Sorting Filter Clicked for ${selectedValue} `;
    handleClickSortIndex(locale, eventName);

    // Find the full option object
    const selectedOption = options.find((option: Option) => option.value.toString() === selectedValue);

    if (selectedOption && setSelectedOption) {
      setSelectedOption({ ...selectedOption, value: `${mainIndex}_${selectedOption.value}` });
      setSelectedValue(selectedValue);
    }
  };

  return (
    <div className="relative">
      <select
        value={selectedValue}
        onChange={handleChange}
        className={`w-full appearance-none ${selectButtonClassName} rounded-md border border-neutral-300 bg-white p-2 text-gray-700 lg:min-w-[8rem] lg:pr-8`}
        style={{
          border: 'none',
          appearance: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
        }}
      >
        <option value="" disabled>
          Please Select One
        </option>
        {options.map((option: Option, index: number) => (
          <option key={index} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>

      {/* Custom ChevronDownIcon */}
      <ChevronDownIcon
        className="pointer-events-none absolute right-10 top-1/2 h-15 w-18 -translate-y-1/2 transform font-bold text-[#127e57]"
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
      />
    </div>
  );
};

export default SortDropdown;
